import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PageStyles.css';

const AutoPage = () => {
  const [activeTimeGain, setActiveTimeGain] = useState(0);

  const timeGains = [
    {
      title: "3h par jour économisées",
      description: "L'automatisation complète vous fait gagner 3 heures par jour sur la gestion de planning. Plus besoin de passer des appels, envoyer des emails ou gérer les conflits d'horaires manuellement. Votre temps est précieux, nous le préservons."
    },
    {
      title: "Zéro temps de traitement", 
      description: "Vos clients reçoivent instantanément leurs créneaux disponibles. Aucun délai d'attente, aucune file d'attente, aucune intervention humaine nécessaire. L'IA traite les demandes en millisecondes, pas en heures."
    },
    {
      title: "Planning optimisé 24h/24",
      description: "Pendant que vous dormez, l'IA continue d'optimiser votre planning. Elle analyse les tendances, anticipe les besoins et prépare votre journée idéale. Vous vous réveillez avec un planning parfait, sans effort."
    },
    {
      title: "Réactivité instantanée",
      description: "Vos clients obtiennent une réponse immédiate, même à 3h du matin. Plus de clients perdus à cause de délais de réponse. L'automatisation garantit une disponibilité permanente et une satisfaction client maximale."
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Header */}
        <div className="page-header">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
            <Link to="/" style={{fontSize: '1.5rem', fontWeight: '700', color: '#60a5fa', textDecoration: 'none'}}>
              Monagora
            </Link>
            <Link to="/" style={{color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem'}}>
              ← Retour à l'accueil
            </Link>
          </div>
          
          <div style={{textAlign: 'center', marginBottom: '1rem'}}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(59, 130, 246, 0.1)',
              color: '#60a5fa',
              padding: '0.5rem 1rem',
              borderRadius: '50px',
              fontSize: '0.9rem',
              fontWeight: '600',
              border: '1px solid rgba(59, 130, 246, 0.3)'
            }}>
              Automatisation Totale
            </span>
          </div>
          
          <h1 className="page-title">
            Récupérez Votre Temps
          </h1>
          <p className="page-subtitle">
            L'automatisation complète vous fait gagner 3 heures par jour. 
            Pendant que l'IA gère votre planning, vous vous concentrez sur ce qui compte vraiment.
          </p>
        </div>

        {/* Section principale avec dashboard temps gagné */}
        <div className="page-section">
          <h2 className="section-title">Votre Temps Récupéré</h2>
          
          <div className="section-content">
            <div className="content-text">
              <h3 style={{color: '#60a5fa', fontSize: '1.8rem', marginBottom: '2rem'}}>
                Automatisation = Temps Libéré
              </h3>
              
              <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus d'appels téléphoniques interminables</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus d'emails de confirmation à envoyer</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus de gestion des conflits d'horaires</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus de saisie manuelle de données</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus de rappels manuels à organiser</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Plus de stress lié à la planification</span>
                </div>
              </div>
            </div>
            
            <div className="content-visual">
              <div className="ai-dashboard">
                <div className="dashboard-header">
                  <div className="dashboard-title">Temps Récupéré</div>
                  <div className="dashboard-subtitle">Par jour, par semaine, par mois</div>
                </div>
                
                <div className="ai-metrics">
                  <div className="ai-metric">
                    <span className="ai-metric-value">3h</span>
                    <span className="ai-metric-label">Par jour</span>
                  </div>
                  <div className="ai-metric">
                    <span className="ai-metric-value">15h</span>
                    <span className="ai-metric-label">Par semaine</span>
                  </div>
                  <div className="ai-metric">
                    <span className="ai-metric-value">60h</span>
                    <span className="ai-metric-label">Par mois</span>
                  </div>
                </div>
                
                <div className="ai-activity">
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <span className="activity-text">Temps économisé aujourd'hui : 2h45</span>
                    <span className="activity-time">En temps réel</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <span className="activity-text">RDV automatiques : 12 ce matin</span>
                    <span className="activity-time">Sans intervention</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <span className="activity-text">Emails envoyés automatiquement : 8</span>
                    <span className="activity-time">Temps économisé : 45min</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <span className="activity-text">Planning optimisé pour demain</span>
                    <span className="activity-time">Temps économisé : 1h30</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section gains de temps avec nouveau layout */}
        <div className="page-section">
          <h2 className="section-title">Comment l'Automatisation Vous Fait Gagner du Temps</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '4rem', alignItems: 'flex-start'}}>
            {/* Colonne de gauche - Titres courts */}
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              {timeGains.map((gain, index) => (
                <div
                  key={index}
                  style={{
                    padding: '1.5rem 2rem',
                    background: activeTimeGain === index 
                      ? 'rgba(96, 165, 250, 0.15)' 
                      : 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '12px',
                    border: activeTimeGain === index 
                      ? '2px solid rgba(96, 165, 250, 0.3)' 
                      : '1px solid rgba(255, 255, 255, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={() => setActiveTimeGain(index)}
                >
                  {/* Indicateur visuel à gauche */}
                  <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: activeTimeGain === index ? '4px' : '0px',
                    background: 'linear-gradient(135deg, #60a5fa, #a78bfa)',
                    transition: 'width 0.3s ease'
                  }}></div>
                  
                  <h3 style={{
                    color: activeTimeGain === index ? '#60a5fa' : '#f1f5f9',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: 0,
                    transition: 'color 0.3s ease',
                    transform: activeTimeGain === index ? 'scale(1.02)' : 'scale(1)',
                    transformOrigin: 'left center'
                  }}>
                    {gain.title}
                  </h3>
                </div>
              ))}
            </div>
            
            {/* Colonne de droite - Détails */}
            <div style={{
              padding: '3rem',
              background: 'rgba(255, 255, 255, 0.08)',
              backdropFilter: 'blur(20px)',
              borderRadius: '20px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              minHeight: '300px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: 'linear-gradient(135deg, #60a5fa, #a78bfa)',
                opacity: 0.8
              }}></div>
              
              <h3 style={{
                color: '#60a5fa',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
              }}>
                {timeGains[activeTimeGain].title}
              </h3>
              
              <p style={{
                color: '#e2e8f0',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                margin: 0,
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
              }}>
                {timeGains[activeTimeGain].description}
              </p>
            </div>
          </div>
        </div>

        {/* Section métriques temps */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Votre Temps Récupéré en Chiffres</h2>
          
          <div className="metrics-grid">
            <div className="metric-item">
              <span className="metric-number">3h</span>
              <span className="metric-label">Par jour économisées</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">15h</span>
              <span className="metric-label">Par semaine libérées</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">60h</span>
              <span className="metric-label">Par mois récupérées</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">720h</span>
              <span className="metric-label">Par an de temps libre</span>
            </div>
          </div>
        </div>

        {/* Section ce que vous pouvez faire avec ce temps */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Ce Que Vous Pouvez Faire Avec 3h Par Jour</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginTop: '2rem'}}>
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                💼
              </div>
              <h3>Développer Votre Business</h3>
              <p>
                Concentrez-vous sur l'acquisition de nouveaux clients et le développement de votre activité
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #f59e0b, #d97706)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                👨‍👩‍👧‍👦
              </div>
              <h3>Plus de Temps Familial</h3>
              <p>
                Passez plus de temps avec vos proches au lieu de gérer des plannings
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                🏃‍♂️
              </div>
              <h3>Activités Personnelles</h3>
              <p>
                Sport, loisirs, formation... Développez-vous personnellement
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #ef4444, #dc2626)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                😴
              </div>
              <h3>Moins de Stress</h3>
              <p>
                Éliminez la charge mentale liée à la gestion manuelle des plannings
              </p>
            </div>
          </div>
        </div>

        {/* Navigation vers autres pages */}
        <div className="page-section" style={{borderBottom: 'none'}}>
          <h2 className="mode-page-hero-main-title-heading">Découvrez Nos Autres Avantages</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem'}}>
            <Link to="/ia-vs-humain" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #a78bfa, #7c3aed)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  🤖
                </div>
                <h3 style={{color: '#a78bfa'}}>IA vs Humain</h3>
                <p>
                  Découvrez pourquoi notre IA surpasse un employé humain
                </p>
                <div style={{marginTop: '1rem', color: '#a78bfa', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
            
            <Link to="/gains-financiers" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  💰
                </div>
                <h3 style={{color: '#10b981'}}>Gains Financiers</h3>
                <p>
                  Calculez vos économies réelles avec notre solution
                </p>
                <div style={{marginTop: '1rem', color: '#10b981', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoPage; 